<template>
  <svg
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <!-- Chart card background -->
    <rect
      x="40"
      y="30"
      width="120"
      height="90"
      rx="8"
      fill="#f5f3ff"
      opacity="0.6"
      stroke="#e9d5ff"
      stroke-width="1"
      stroke-dasharray="3 3"
    />

    <!-- Background reference bars (lighter) -->
    <rect x="58" y="55" width="14" height="50" rx="3" fill="#ede9fe" />
    <rect x="91" y="45" width="14" height="60" rx="3" fill="#ede9fe" />
    <rect x="124" y="40" width="14" height="65" rx="3" fill="#ede9fe" />

    <!-- Animated value bars -->
    <rect
      x="58"
      y="75"
      width="14"
      height="30"
      rx="3"
      fill="#a78bfa"
      class="bar1"
    />
    <rect
      x="91"
      y="63"
      width="14"
      height="42"
      rx="3"
      fill="#8b5cf6"
      class="bar2"
    />
    <rect
      x="124"
      y="53"
      width="14"
      height="52"
      rx="3"
      fill="#7c3aed"
      class="bar3"
    />
  </svg>
</template>

<style scoped>
@keyframes grow1 {
  0%,
  100% {
    height: 30px;
    y: 75px;
  }
  50% {
    height: 38px;
    y: 67px;
  }
}
@keyframes grow2 {
  0%,
  100% {
    height: 42px;
    y: 63px;
  }
  50% {
    height: 50px;
    y: 55px;
  }
}
@keyframes grow3 {
  0%,
  100% {
    height: 52px;
    y: 53px;
  }
  50% {
    height: 60px;
    y: 45px;
  }
}
.bar1 {
  animation: grow1 3s ease-in-out infinite;
}
.bar2 {
  animation: grow2 3s ease-in-out infinite 0.3s;
}
.bar3 {
  animation: grow3 3s ease-in-out infinite 0.6s;
}
</style>
